import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default class RecordOverlineHelper extends Helper {
  // Services
  @service recordPresentation;

  // Hooks
  compute([record]) {
    return this.recordPresentation.recordOverline(record);
  }
}
